import { render, staticRenderFns } from "./ComponentDownloadStatus.vue?vue&type=template&id=654c065a"
import script from "./ComponentDownloadStatus.vue?vue&type=script&lang=js"
export * from "./ComponentDownloadStatus.vue?vue&type=script&lang=js"
import style0 from "./ComponentDownloadStatus.vue?vue&type=style&index=0&id=654c065a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports